import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-space-between flex-md-row flex-column mb-4",
        },
        [
          _c(VTextField, {
            staticClass: "mr-md-2 mb-6 mb-md-0",
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
              type: "date",
              clearable: "",
              dense: "",
              "hide-details": "",
              outlined: "",
              rules: [_vm.rules.required],
            },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _c(VTextField, {
            staticClass: "ml-0 ml-lg-4",
            attrs: {
              label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
              type: "date",
              clearable: "",
              dense: "",
              "hide-details": "",
              outlined: "",
              rules: [_vm.rules.dateRange(_vm.startDate, _vm.endDate)],
            },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex flex-column flex-md-row" },
        [
          _c(VTextField, {
            staticClass: "flex-grow-1",
            attrs: {
              autocomplete: "null",
              name: "search",
              dense: "",
              placeholder: "Search by customer or product name",
              "append-icon": "mdi-magnify",
              outlined: "",
              clearable: "",
              "hide-details": "",
              label: "Search",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchTerms,
              callback: function ($$v) {
                _vm.searchTerms = $$v
              },
              expression: "searchTerms",
            },
          }),
          _c(VSelect, {
            staticClass: "my-2 my-md-0 ml-0 ml-md-4 flex-grow-0",
            attrs: {
              outlined: "",
              "hide-details": "",
              dense: "",
              label: "Order Status",
              items: _vm.availableStatuses,
              "item-text": "name",
              "item-value": "value",
              multiple: "",
            },
            model: {
              value: _vm.status,
              callback: function ($$v) {
                _vm.status = $$v
              },
              expression: "status",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-center my-2" },
        [_c(VBtn, { on: { click: _vm.search } }, [_vm._v(" Submit ")])],
        1
      ),
      _c(
        "div",
        { staticClass: "text-center text-caption font-weight-light mt-4" },
        [
          _c(VDivider),
          _vm._v(
            " Found " +
              _vm._s(_vm._f("formatInteger")(this.pagination.totalSize)) +
              " open orders "
          ),
        ],
        1
      ),
      _c(
        "infinite-scroll",
        {
          key: _vm.infiniteScrollKey,
          attrs: { totalPages: _vm.pagination.totalPages },
          on: {
            fetchData: _vm.fetchSalesOrders,
            "update:totalPages": function ($event) {
              return _vm.$set(_vm.pagination, "totalPages", $event)
            },
            "update:total-pages": function ($event) {
              return _vm.$set(_vm.pagination, "totalPages", $event)
            },
          },
        },
        _vm._l(_vm.salesOrders, function (order) {
          return _c("order-status", { key: order.id, attrs: { order: order } })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }